import app from 'flarum/forum/app';
import AcceptTermsModal from './AcceptTermsModal';

type RedirectToCheckoutOptions = { session_id: string };

export default class Handler {
  protected checkoutUrl = app.forum.attribute<string>('apiUrl') + '/blomstra-payments/stripe/checkout';
  protected type: string;
  protected params: Record<string, any>;

  constructor(type: string, params: Record<string, any>) {
    this.type = type;
    this.params = params;
  }

  checkout() {
    if (app.forum.attribute<string>('blomstra-payments.link-to-terms')) {
      app.modal.show(
        AcceptTermsModal,
        {
          onsubmit: () => {
            this.doCheckout();
          }, // @ts-ignore stack it for Flarum v1.5 as bounties already open a modal.
        },
        true
      );
    } else {
      this.doCheckout();
    }
  }

  doCheckout() {
    const params = this.params || {};
    params.type = this.type;

    app
      .request<RedirectToCheckoutOptions>({
        url: this.checkoutUrl,
        method: 'POST',
        body: params,
      })
      .then(this.redirect.bind(this));
  }

  redirect(response: RedirectToCheckoutOptions) {
    const sessionId = response.session_id;

    let stripe = Stripe(app.forum.pk());

    stripe.redirectToCheckout({ sessionId });
  }
}
